/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Link, Typography } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import Accordion from '../UI/Legal/Accordion';

// Styles
const useStyles = makeStyles((theme) => ({
  image: {
    position: 'relative',
    height: 150,
    zIndex: 101,
    marginRight: 15,
    marginLeft: 15,
    display: 'inline-block',
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(4),
    },
  },
  locationHeader: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingTop: 20,
  },
  locationSubHeader: {
    fontWeight: 'bold',
    marginTop: '10px',
  },
  locationSubHeaderGreen: {
    color: theme.palette.interactive.main,
    fontWeight: 'bold',
    marginTop: '10px',
  },
  locationCard: {
    position: 'absolute',
    top: 0,
    left: 40,
    width: '90%',
    zIndex: 101,
    [theme.breakpoints.down('md')]: {
      left: 0,
      width: '100%',
    },
  },
  grayBackgroundContainer: {
    width: '100%',
    minHeight: 300,
    backgroundColor: '#F0F0F0',
    marginBottom: '40px',
    paddingBottom: '40px',
  },
  generalInfoContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  generalInfoSubContainer: {
    [theme.breakpoints.between('xs', '900')]: {
      width: '300px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  cargoContainer: {
    marginTop: 30,
  },
  phoneText: {
    textAlign: 'center',
    [theme.breakpoints.between('xs', '900')]: {
      textAlign: 'left',
    },
  },
  generalInfoSubContainerContact: {
    width: 250,
    [theme.breakpoints.between('xs', '900')]: {
      width: '300px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '80%',
    },
  },
  openingHoursButton: {
    textAlign: 'center',
    marginTop: 10,
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const Location = (props) => {
  const classes = useStyles();
  const { data } = props;
  const cargoImages = data.cargoImagesArray ? data.cargoImagesArray.split(' ') : [];
  const [expandedCargo, setExpandedCargo] = useState(false);
  const [expandedInquiries, setExpandedInquiries] = useState(false);

  return (
    <Box pt={14} position="relative">
      <Box mt={1} />
      <Grid container>
        <Grid container className={classes.grayBackgroundContainer}>
          <Grid item xs={12} md={12}>
            <Typography variant="h4" className={classes.locationHeader}>{`${data.airportName} (${data.airportCode}/${data.cargoCode})`}</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.generalInfoContainer}>
              <Box className={classes.generalInfoSubContainer}>
                {data.stationManager && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" className={classes.locationSubHeader}>Station manager</Typography>
                    <Typography>
                      <b>Name:</b>
                      {' '}
                      {data.stationManager}
                    </Typography>
                  </Grid>
                )}
                {data.operationManager && (
                  <Grid item xs={12}>
                    <Typography variant="subtitle2" className={classes.locationSubHeader}>Operations manager</Typography>
                    <Typography>
                      <b>Name:</b>
                      {' '}
                      {data.operationManager}
                    </Typography>
                  </Grid>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.generalInfoContainer}>
              <Box className={classes.generalInfoSubContainer}>
                <Grid item xs={12} className={classes.phoneText}>
                  <Typography variant="subtitle2" className={classes.locationSubHeader}>Opening hours</Typography>
                  <Typography>
                    Weekdays:
                    {' '}
                    {data.openingHoursWeekdays}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.phoneText}>
                  <Typography>
                    Saturdays:
                    {' '}
                    {data.openingHoursSaturdays}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.phoneText}>
                  <Typography>
                    Sundays:
                    {' '}
                    {data.openingHoursSundays}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.openingHoursButton}>
                  <Typography onClick={() => setExpandedInquiries(!expandedInquiries)}>Deviating Opening Hours</Typography>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.generalInfoContainer}>
              <Box className={classes.generalInfoSubContainerContact}>
                <Typography variant="subtitle2" className={classes.locationSubHeader}>Contact Information</Typography>
                <Typography>
                  <b>Email:</b>
                  {' '}
                  <Link href={`mailto:${data.handlingEmail}`}>{data.handlingEmail}</Link>
                </Typography>
                <Typography>
                  <b>Phone:</b>
                  {' '}
                  <Link href={`phone:${data.stationPhone}`}>{data.stationPhone}</Link>
                </Typography>
                <Typography>
                  <b>Address:</b>
                  {' '}
                  <Link href={`http://maps.google.com/?q=${data.stationAddress}`}>{data.stationAddress}</Link>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Accordion title="VHF">
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" className={classes.locationSubHeader}>VHF</Typography>
                  <Typography>{data.vhf}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" className={classes.locationSubHeader}>VHF (De-ice)</Typography>
                  <Typography>{data.vhfDeIce}</Typography>
                </Grid>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion title="TTY Addresses">
                <Typography>
                  <b>LDM:</b>
                  {' '}
                  {data.ldm}
                  <br />
                  <b>MVT:</b>
                  {' '}
                  {data.mvt}
                  <br />
                  <b>PSM/PTM/PAL/CAL:</b>
                  {' '}
                  {data.psmptmpalcal}
                  <br />
                  <b>SOM:</b>
                  {' '}
                  {data.som}
                  <br />
                  <b>PNL:</b>
                  {' '}
                  {data.pnl}
                  <br />
                  <b>SSM/ASM/FD:</b>
                  {' '}
                  {data.ssmasmfd}
                  <br />
                  <b>WT-WORLD-TRACER:</b>
                  {' '}
                  {data.wtWorldTracer}
                  <br />
                </Typography>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion title="Lost Luggage">
                <Typography>
                  <b>Phone:</b>
                  {' '}
                  <Link href={`mailto:${data.lostLuggagePhone}`}>{data.lostLuggagePhone}</Link>
                  <br />
                  <b>Email:</b>
                  {' '}
                  <Link href={`mailto:${data.lostLuggageEmail}`}>{data.lostLuggageEmail}</Link>
                  <br />
                </Typography>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion title="Other Inquiries / Deviating Opening Hours" expandedSeparatedButton={expandedInquiries} setExpandedSeparatedButton={setExpandedInquiries} extraButton>
                <Typography>
                  <b>Catering:</b>
                  {' '}
                  {data.catering}
                  {' - '}
                  <Link href={`mailto:${data.cateringEmail}`}>{data.cateringEmail}</Link>
                  <br />
                  <b>Fuel:</b>
                  {' '}
                  {data.fuel}
                  {' - '}
                  <Link href={`mailto:${data.fuelEmail}`}>{data.fuelEmail}</Link>
                  <br />
                  <b>DCS system:</b>
                  {' '}
                  {data.dcsSystem}
                  <br />
                  <b>DCS related inquiries:</b>
                  {' '}
                  <Link href={`mailto:${data.dcsEmail}`}>{data.dcsEmail}</Link>
                  <br />
                  <b>BRS system:</b>
                  {' '}
                  Amadeus BRS
                  <br />
                  <b>Deviating Opening hours:</b>
                  {' '}
                  <Box>
                    {!data.stationDeviatingHours ? (<Typography>-</Typography>) : (<ReactMarkdown className={classes.bodyText}>{data.stationDeviatingHours}</ReactMarkdown>)}
                  </Box>
                </Typography>
              </Accordion>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box mt={1} />
      <Grid container className={classes.cargoContainer}>
        <Grid container className={classes.grayBackgroundContainer}>
          <Grid item xs={12} md={12}>
            <Typography variant="h4" className={classes.locationHeader}>Cargo</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.generalInfoContainer}>
              <Box className={classes.generalInfoSubContainer}>
                <Typography variant="subtitle2" className={classes.locationSubHeader}>Terminal manager</Typography>
                <Typography>
                  <b>Name:</b>
                  {' '}
                  {data.cargoTerminalName}
                </Typography>
                <Typography>
                  <b>Phone:</b>
                  {' '}
                  <Link href={`phone:${data.stationPhone}`}>{data.cargoTerminalPhone}</Link>
                  <br />
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.generalInfoContainer}>
              <Box className={classes.generalInfoSubContainer}>
                <Grid item xs={12} className={classes.phoneText}>
                  <Typography variant="subtitle2" className={classes.locationSubHeader}>Opening hours</Typography>
                  <Typography>
                    Weekdays:
                    {' '}
                    {data.cargoOpeningHoursWeekdays}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.phoneText}>
                  <Typography>
                    Saturdays:
                    {' '}
                    {data.cargoOpeningHoursSaturday}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.phoneText}>
                  <Typography>
                    Sundays:
                    {' '}
                    {data.cargoOpeningHoursSunday}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.openingHoursButton}>
                  <Typography onClick={() => setExpandedCargo(!expandedCargo)}>Deviating Opening Hours</Typography>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box className={classes.generalInfoContainer}>
              <Box className={classes.generalInfoSubContainerContact}>
                <Typography variant="subtitle2" className={classes.locationSubHeader}>Contact Information</Typography>
                <Typography>
                  <b>Email:</b>
                  {' '}
                  <Link href={`mailto:${data.cargoEmail}`}>{data.cargoEmail}</Link>
                </Typography>
                <Typography>
                  <b>Phone:</b>
                  {' '}
                  <Link href={`phone:${data.cargoContactPhone}`}>{data.cargoContactPhone}</Link>
                </Typography>
                <Typography>
                  <b>Address:</b>
                  {' '}
                  <Link href={`http://maps.google.com/?q=${data.cargoContactAddress}`}>{data.cargoContactAddress}</Link>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <Accordion title="Facilities">
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" className={classes.locationSubHeader}>Cooler:</Typography>
                  <Typography>
                    {data.cargoFacilitiesCooler && data.cargoFacilitiesCooler !== 'No' ? `${data.cargoFacilitiesCooler} m` : ''}
                    {data.cargoFacilitiesCooler && data.cargoFacilitiesCooler === 'No' ? 'No' : ''}
                    {data.cargoFacilitiesCooler && data.cargoFacilitiesCooler !== 'No' ? <sup>2</sup> : ''}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" className={classes.locationSubHeader}>Freezer:</Typography>
                  <Typography>{data.cargoFacilitiesFreezer}</Typography>
                </Grid>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion title="Cargo Handling Agent">
                <Box>
                  <Typography>
                    {`WGH Cargo ${data.airportName} is operating as the air cargo handling agent for the following companies:`}
                    <br />
                  </Typography>
                  <Grid container spacing={3} className={classes.cargoContainer}>
                    {cargoImages.map((item) => (
                      <Grid item md={3} xs={3}>
                        <img src={`/static/images/cargoImages/${item}.png`} priority objectFit="scale-down" width="100%" height="auto" alt="logo" />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion title="Special Cargo Handling">
                <Typography>
                  <b>Live Animals (AVI):</b>
                  {' '}
                  {data.cargoHandlingAVI}
                  <br />
                  <b>Dangerous Goods (DG):</b>
                  {' '}
                  {data.cargoHandlingDG}
                  <br />
                  <b>Human Remains (HUM):</b>
                  {' '}
                  {data.cargoHandlingHUM}
                  <br />
                  <b>Radioactive (RRY):</b>
                  {' '}
                  {data.cargoHandlingRRY}
                  <br />
                  <b>Valuable Cargo (VAL):</b>
                  {' '}
                  {data.cargoHandlingVAL}
                  <br />
                </Typography>
              </Accordion>
            </Grid>
            <Grid item xs={12} md={6}>
              <Accordion title="Deviating Opening Hours" expandedSeparatedButton={expandedCargo} setExpandedSeparatedButton={setExpandedCargo} extraButton>
                <ReactMarkdown className={classes.bodyText}>{data.cargoHandlingDeviatingHours}</ReactMarkdown>
              </Accordion>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Location;
